import { ReactComponent as StarIcon } from '../../assets/star.svg';
import { ReactComponent as StarActiveIcon } from '../../assets/starActive.svg';

import { IconWrapper } from './iconWrapper';
import { IconProps } from './model';

export const FavouritesIcon = (props: IconProps) => {
    return <IconWrapper {...props}>{props.active ? <StarActiveIcon /> : <StarIcon />}</IconWrapper>;
};
